// extracted by mini-css-extract-plugin
export default {"productsSwiper":"productsSlider_productsSwiper__pp55m","products":"productsSlider_products__hX2eH"};